<template>
  <modal class="modal" name="new-features-modal" transition="pop-out" :width="modalWidth" height="auto" :adaptive="true" :clickToClose="false">
    <div class="flex-row justify-center fl w-100 h-100 pb2">
      <div class="w-100 h-100 flex justify-center mt4">
        <img class="w-25" src="../../../assets/logo-white.svg" alt="BeatHey Logo">
      </div>
      <div class="h-100 w-100 nfmDiv">
        <h1 v-if="!msisdn" v-html="news[0].title"/>
        <h1 v-if="msisdn" v-html="news[1].title"/>
        <div class="NFMspan">
          <span v-if="!msisdn" v-html="news[0].content" style="font-size:25px;"/>
          <span v-if="msisdn" v-html="news[1].content" style="font-size:25px;"/>
        </div>
      </div>
      <div class="flex justify-center mb3 mt3">
        <button @click="Enviar" class="NFMcallToAction">{{ $t("app.notShowAgain")}}</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import { mapActions, mapGetters } from 'vuex'
  const MODAL_WIDTH = 1000

  export default {
    name: 'new-features-modal',
    components: {ClipLoader},
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '20px',
        newsResponse: null,
        msisdn: null
      }
    },
    created () {
      this.modalWidth = window.innerWidth < MODAL_WIDTH
        ? MODAL_WIDTH / 2
        : MODAL_WIDTH
      this.msisdn = localStorage.getItem('msisdn')
    },
    methods: {
      Cerrar () {
        this.$modal.hide('new-features-modal')
      },
      Enviar () {
        let data = {}
        if (!this.msisdn) {
          data = {
            'user_id': this.user.id,
            'feature_id': this.news[0].id,
            'type': this.news[0].type,
            'ln': this.language
          }
        } else {
          data = {
            'user_id': this.user.id,
            'feature_id': this.news[1].id,
            'type': this.news[1].type,
            'ln': this.language
          }
        }
        this.setNewFeatureSeen(data)
        this.Cerrar()
      },
      ...mapActions('news', [
        'getNewsFeatures',
        'setNewFeatureSeen'
      ])
    },
    computed: {
      ...mapGetters('news', [
        'news'
      ]),
      ...mapGetters('translator', [
        'language'
      ]),
      ...mapGetters('user', [
        'user'
      ])
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  .news-content {
    height: 85%
  }
  .img-2 {
    height: 15%;
  }
  .news-text{
    overflow-y: scroll;
    overflow-x: hidden;
    margin-bottom: 0;
  }

  a{
    color: #fff !important;
  }

  .nfmDiv{
    text-align: center;
  }

  .NFMcallToAction{
    height: 40px;
    border-radius: 35px 35px 35px 35px;
    outline: 0;
    border-width: 1px;
    border-color: #E6007E;
    background-color: #E6007E;
    color: #fff;
    outline-offset: 1px;
    overflow: hidden;
    font-weight: bold;
  }

  .NFMcallToAction:hover {
    background-color: #fff !important;
    color: #E6007E !important ;
  }

  .NFMspan{
    margin-bottom: 1rem;
    p{
      margin: 20px;
    }
    height: 240px;
    overflow-y: scroll;
  }

  .modal {
    z-index: 10000 !important;
  }
  @media screen and (max-height: 630px) {
    .hide-m{
      width: 100vw;    /*  video width / height  */
      height: calc(100vw * (550 / 500));   /*  video height / width  */
    
    }
  }


  @media (max-width: 479px) {
    .news-container {
      flex-direction: column;
    }
    .img-1 {
      width: 100%;
      height: 40%;
    }
    .news-container-2 {
      width: 100%;
    }
    .news-content{
      padding: 1rem;
    }
    .NFMspan{
      margin: 0px 20px 20px 20px;
      text-align: center;
      overflow-y: scroll;
      overflow-x: hidden;
      height: 30vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/newFeaturesNotice/NewFeaturesModal.vue